import HeroImage2 from "../../assets/images/hero_bg.jpg";
import HeroImage1 from "../../assets/images/hero_bg_2.jpg";
import FeatureImage1 from "../../assets/images/committed-quality.jpg";
import FeatureImage2 from "../../assets/images/robust-product-portfolio.jpeg";

export const HomeContent = {
  carousel: {
    images: [
      {
        url: HeroImage1,
        header: `Welcome to <strong style="color: #26608d">RAYKOS</strong>`,
        description: `<span style="font-weight: 300">We belive we can change the world of medicines by uniting science, technology and talent</span>`
      },
      {
        url: HeroImage2,
        header: "Advanced Medicine Assured",
      },
    ],
  },
  sectionBanner1: {
    header: "Unleash Your Potential with RAYKOS",
    description:
      "Discover endless possibilities for growth and success in the pharmaceutical industry. Explore our range of high-quality products, innovative services, and exciting business opportunities.",
  },
  featureBlock1: {
    header: "Quality and Safety",
    description: `
    At RAYKOS, we prioritize quality and safety throughout our operations. From research and development to manufacturing and distribution, we adhere to strict quality control measures to ensure that our products meet the highest standards of safety, efficacy, and regulatory compliance.`,
    image: FeatureImage1,
    imagePosition: "left",
  },
  featureBlock2: {
    header: "Robust Product Portfolio",
    description: `
    Leveraging India’s globally competitive cost effective and talented team, we have a range of affordable products which are accessible across the globe. From development to commercialization, our growth is aided by cost-effective drug development and substantial manufacturing.`,
    image: FeatureImage2,
    imagePosition: "right",
  },
  threeColumnBlock: {
    cards: [
      {
        header: "Our Vision",
        description:
          "To become one of the leading Indian Pharmaceutical companies in the Global market in developing novel drug delivery systems to help people lead healthier and Quality life.",
        bodyClass: "text-center",
      },
      {
        header: "Our Mission",
        description:
          "To provide better healthcare to the humanity with affordable drugs of uncompromised Quality and to pursue excellence in healthcare through innovation & empowered personnel",
        bodyClass: "text-center",
      },
      {
        header: "Our Core Values",
        description:
          "Our core values of innovation, integrity, quality, customer focus, and collaboration are at the heart of everything we do. These values drive our decisions, guide our actions, and shape our organizational culture.",
        bodyClass: "text-center",
      },
    ],
  },
  sectionBanner2: {
    header: "Discover Our Pharmaceutical Excellence",
    description:
      "Browse our comprehensive portfolio of innovative pharmaceutical products, from immediate-release formulations to specialized delivery systems designed to improve patient outcomes.",
    button: {
      url: "/products",
      name: "View Products",
    },
  }
};
